// Built-in demo project for SwitchR.
//
// The demo is the user-curated `.drawio` file (SwitchR-native export) embedded
// as `demoProjectXml.js`. It is parsed through the SAME import path used for
// regular file imports (`parseDrawioWithReport`), guaranteeing it behaves
// exactly like an imported document and stays 100% consistent with the format.
//
// It showcases the major features in a realistic campus-network scenario:
//   - Standard topology page + an ALIAS page ("Standort B")
//   - DETAIL pages incl. a passive patch panel (dual-anchor / both-sides layout)
//   - A LOCATION plan with device markers
//   - VLANs with ZONES, tagged/untagged ports, virtual interfaces (SVIs), LAG,
//     and connection bundling
//   - Two intentional Design-Check findings (a duplicate IP + a VLAN mismatch)
//
// buildDemoProject() returns a parsed `doc` which store.loadDoc() stores as a
// NEW local project (the currently open project is preserved). The large XML is
// lazily imported so it never weighs on the initial bundle.

import { parseDrawioWithReport } from './drawio';

export async function buildDemoProject() {
  const { DEMO_DRAWIO_XML } = await import('./demoProjectXml');
  const { doc } = parseDrawioWithReport(DEMO_DRAWIO_XML);
  return doc;
}
